import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["id", "className", "style", "prefixCls", "data", "children", "value", "defaultValue", "required", "readonly", "error", "errorNode", "disabled", "dropdownMatchWidth", "noResultFound", "virtualized", "listHeight", "listItemHeight", "searchKeyword", "placeholder", "selectAllText", "onSearch", "visible", "defaultVisible", "onVisibleChange", "getPopupContainer", "getScrollContainer", "dropdownAlwaysDown", "dropdownRenderMode", "dropdownRender", "dropdownStyle", "dropdownClassName", "multiple", "showMultipleTags", "showAllSelectedTag", "showSelectAll", "onClear", "onSelect", "filterOption", "valueTemplate", "itemTemplate", "badgeTemplate", "prefixTemplate", "suffixTemplate", "groupTemplate", "valueKey", "labelKey", "childrenKey", "disabledItemValues", "spacing", "inputProps", "showClear", "showDivider", "maxHeight"];
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useState, useCallback, useMemo, useEffect, useImperativeHandle } from 'react';
import { getEventSource, getActiveElement } from '../utils/shadowDomUtils';
import ClassNames from 'classnames';
import { CSSTransition as ReactCSSTransition } from 'react-transition-group';
import OptionListContext from '../select/OptionListContext';
import DropdownMenu from '../select/DropdownMenu';
import { Tag } from '../tag';
import { flattenItemsFun } from '../select/utils';
import useOptions from '../select/useOptions';
import useFilterOptions from '../select/useFilterOptions';
import DomHandler from '../select/DomHandler';
import { _uuid, toArray, useControlled, KEY_VALUES, useClickOutside, useKeydownOutside, Portal, mergeRefs } from '../utils';
import { useLocalization } from '@appkit4/react-api';
var SELECT_ALL_KEY = 'appkit4-select-all-key';

// eslint-disable-next-line react/display-name
export var CSSTransition = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var disabled = props.disabled || props.options && props.options.disabled;
  var onEnter = function onEnter(node, isAppearing) {
    props.onEnter && props.onEnter(node, isAppearing); // component
    props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
  };

  var onEntering = function onEntering(node, isAppearing) {
    props.onEntering && props.onEntering(node, isAppearing); // component
    props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
  };

  var onEntered = function onEntered(node, isAppearing) {
    props.onEntered && props.onEntered(node, isAppearing); // component
    props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
  };

  var onExit = function onExit(node) {
    props.onExit && props.onExit(node); // component
    props.options && props.options.onExit && props.options.onExit(node); // user option
  };

  var onExiting = function onExiting(node) {
    props.onExiting && props.onExiting(node); // component
    props.options && props.options.onExiting && props.options.onExiting(node); // user option
  };

  var onExited = function onExited(node) {
    props.onExited && props.onExited(node); // component
    props.options && props.options.onExited && props.options.onExited(node); // user option
  };

  if (disabled) {
    return props["in"] ? props.children : null;
  } else {
    var immutableProps = {
      nodeRef: props.nodeRef,
      "in": props["in"],
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited
    };
    var mutableProps = {
      classNames: props.classNames,
      timeout: props.timeout,
      unmountOnExit: props.unmountOnExit
    };
    var mergedProps = _extends({}, mutableProps, props.options || {}, immutableProps);
    return /*#__PURE__*/React.createElement(ReactCSSTransition, mergedProps, props.children);
  }
});
var Combobox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ClassNames, _resultMessage;
  var id = props.id,
    className = props.className,
    style = props.style,
    _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'ap-combobox' : _props$prefixCls,
    data = props.data,
    children = props.children,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    required = props.required,
    readonly = props.readonly,
    error = props.error,
    errorNode = props.errorNode,
    disabled = props.disabled,
    _props$dropdownMatchW = props.dropdownMatchWidth,
    dropdownMatchWidth = _props$dropdownMatchW === void 0 ? true : _props$dropdownMatchW,
    noResultFound = props.noResultFound,
    virtualized = props.virtualized,
    listHeight = props.listHeight,
    listItemHeight = props.listItemHeight,
    searchKeywordProp = props.searchKeyword,
    placeholder = props.placeholder,
    selectAllText = props.selectAllText,
    onSearch = props.onSearch,
    visibleProp = props.visible,
    _props$defaultVisible = props.defaultVisible,
    defaultVisible = _props$defaultVisible === void 0 ? false : _props$defaultVisible,
    onVisibleChange = props.onVisibleChange,
    getPopupContainer = props.getPopupContainer,
    getScrollContainer = props.getScrollContainer,
    _props$dropdownAlways = props.dropdownAlwaysDown,
    dropdownAlwaysDown = _props$dropdownAlways === void 0 ? true : _props$dropdownAlways,
    _props$dropdownRender = props.dropdownRenderMode,
    dropdownRenderMode = _props$dropdownRender === void 0 ? 'default' : _props$dropdownRender,
    dropdownRender = props.dropdownRender,
    dropdownStyle = props.dropdownStyle,
    dropdownClassName = props.dropdownClassName,
    multiple = props.multiple,
    _props$showMultipleTa = props.showMultipleTags,
    showMultipleTags = _props$showMultipleTa === void 0 ? false : _props$showMultipleTa,
    _props$showAllSelecte = props.showAllSelectedTag,
    showAllSelectedTag = _props$showAllSelecte === void 0 ? true : _props$showAllSelecte,
    _props$showSelectAll = props.showSelectAll,
    showSelectAll = _props$showSelectAll === void 0 ? true : _props$showSelectAll,
    onClear = props.onClear,
    onSelect = props.onSelect,
    filterOption = props.filterOption,
    valueTemplate = props.valueTemplate,
    itemTemplate = props.itemTemplate,
    badgeTemplate = props.badgeTemplate,
    prefixTemplate = props.prefixTemplate,
    suffixTemplate = props.suffixTemplate,
    groupTemplate = props.groupTemplate,
    _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    _props$childrenKey = props.childrenKey,
    childrenKey = _props$childrenKey === void 0 ? 'children' : _props$childrenKey,
    disabledItemValues = props.disabledItemValues,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? 8 : _props$spacing,
    inputProps = props.inputProps,
    _props$showClear = props.showClear,
    showClear = _props$showClear === void 0 ? true : _props$showClear,
    _props$showDivider = props.showDivider,
    showDividerProp = _props$showDivider === void 0 ? true : _props$showDivider,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? 700 : _props$maxHeight,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var childrenAsData = !!(!data && children);
  var _useControlled = useControlled(valueProp, defaultValue),
    internalValue = _useControlled[0],
    setInternalValue = _useControlled[1],
    isControlled = _useControlled[2];
  var _useState = useState(function () {
      if (multiple || valueTemplate) {
        return '';
      } else {
        var newValue = valueProp || defaultValue || '';
        if (newValue) {
          var index = data.findIndex(function (d) {
            return d[valueKey] === newValue;
          });
          if (index > -1) {
            var _label = data[index][labelKey];
            return _label;
          }
        }
        return newValue;
      }
    }),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useControlled2 = useControlled(visibleProp, defaultVisible),
    visible = _useControlled2[0],
    setVisible = _useControlled2[1];
  var _useState2 = useState(inputValue || ''),
    searchWord = _useState2[0],
    setSearchWord = _useState2[1];
  var _useState3 = useState({
      keyboard: false,
      value: ''
    }),
    focusItemValue = _useState3[0],
    setFocusItemValue = _useState3[1];
  var _useState4 = useState(false),
    keyboardFocus = _useState4[0],
    setKeyboardFocus = _useState4[1];
  var _React$useState = React.useState(false),
    inputChanged = _React$useState[0],
    setInputChanged = _React$useState[1];
  var _React$useState2 = React.useState(0),
    inputWidth = _React$useState2[0],
    setInputWidth = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    maxWidth = _React$useState3[0],
    setInputMaxWidth = _React$useState3[1];
  var popupRef = React.useRef(null);
  var targetRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var overlayRef = React.useRef(null);
  var measureRef = React.useRef(null);
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  var controlsId = id || "list-" + _uuid(8, 16);

  // We measure width and set to the input immediately
  React.useLayoutEffect(function () {
    if (showMultipleTags) {
      setInputWidth(measureRef.current.scrollWidth);
    }
  }, [showMultipleTags, multiple, inputValue]);
  React.useEffect(function () {
    if (showMultipleTags && multiple) {
      var _ele = targetRef.current.querySelector('.ap-combox-tags-wrapper');
      if (_ele) {
        _ele.style['maxHeight'] = maxHeight > 0 ? maxHeight - 20 + "px" : '84px';
      }
      var _maxWidth = _ele.clientWidth;
      setInputMaxWidth(_maxWidth - 8);
    }
  }, []);
  useEffect(function () {
    if (multiple || valueTemplate) {
      return function () {};
    } else {
      var index = (data || []).findIndex(function (d) {
        return valueProp && d[valueKey] === valueProp;
      });
      if (index > -1) {
        setInputValue(data[index][labelKey]);
      } else if (valueProp !== null && valueProp !== undefined) setInputValue(valueProp);
      // else setInputValue(valueProp);
    }
  }, [valueProp, setInputValue, data]);
  useEffect(function () {
    var eventHandler = function eventHandler(event) {
      var keycode = event.which;
      if (keycode === 9) {
        setKeyboardFocus(true);
      }
    };
    var eventClickHandler = function eventClickHandler(event) {
      setKeyboardFocus(false);
    };
    window.addEventListener('keydown', eventHandler);
    window.addEventListener('click', eventClickHandler);
    return function () {
      window.removeEventListener('keydown', eventHandler);
      window.removeEventListener('click', eventClickHandler);
    };
  });
  useEffect(function () {
    if (visible && popupRef.current && targetRef.current) {
      var _targetRef$current;
      var containerWidth = (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 ? void 0 : _targetRef$current.offsetWidth;
      if (typeof dropdownMatchWidth === 'number') {
        popupRef.current.style.width = dropdownMatchWidth + "px";
      } else if (dropdownMatchWidth) {
        popupRef.current.style.width = containerWidth + "px";
      }
      alignOverlay();
    }
  }, [popupRef.current, visible, dropdownMatchWidth, internalValue, showMultipleTags]);
  useImperativeHandle(ref, function () {
    return {
      clear: function clear(type) {
        if (type === 'all') {
          handleClear();
        } else if (type === 'input') {
          var _inputRef$current;
          setInputValue('');
          setSearchWord('');
          inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
        }
      },
      current: containerRef.current
    };
  });
  var alignOverlay = function alignOverlay(filterPos) {
    if (getScrollContainer && getScrollContainer() && visible) {
      var rect = targetRef.current.getBoundingClientRect();
      var _ele2 = getScrollContainer && getScrollContainer() || window;
      var eleTop = _ele2.getBoundingClientRect().top;
      if (eleTop - rect.top > 48 && visible) {
        toggleOpen();
        return;
      }
      if (rect.bottom > _ele2.getBoundingClientRect().bottom) {
        toggleOpen();
        return;
      }
    }
    if (!visible) {
      return;
    }
    DomHandler.alignOverlay(overlayRef.current, targetRef.current, dropdownRenderMode === 'portal' ? typeof getPopupContainer === 'function' ? getPopupContainer() : getPopupContainer : 'self', spacing, dropdownAlwaysDown, filterPos, 'right');
  };
  React.useEffect(function () {
    if (visible) {
      alignOverlay();
    }
    var ele = getScrollContainer && getScrollContainer() || window;
    ele.addEventListener('scroll', alignOverlay);
    ele.addEventListener('resize', alignOverlay);
    window.addEventListener('resize', alignOverlay);
    return function () {
      ele.removeEventListener('scroll', alignOverlay);
      window.removeEventListener('resize', alignOverlay);
      ele.removeEventListener('resize', alignOverlay);
    };
  }, [visible, dropdownRenderMode]);
  useEffect(function () {
    var container = popupRef.current;
    if (!container) {
      return;
    }
    var activeItem = container.querySelector('.moved');
    if (!activeItem) {
      return;
    }
    var top = activeItem.offsetTop;
    var bottom = activeItem.offsetTop + activeItem.offsetHeight;
    var viewRectTop = container.scrollTop;
    var viewRectBottom = viewRectTop + container.clientHeight;
    if (top < viewRectTop) {
      container.scrollTop = top;
    } else if (bottom > viewRectBottom) {
      container.scrollTop = bottom - container.clientHeight;
    }
  }, [focusItemValue, popupRef]);
  var handleToggle = function handleToggle() {
    if (!disabled) {
      inputRef.current.focus();
    }
    toggleOpen();
  };
  var toggleOpen = useCallback(function (text) {
    if (disabled) {
      return;
    }
    var newVisible = !visible;
    if (!multiple && newVisible) {
      var labelValue = '';
      var index = data.findIndex(function (d) {
        return d[valueKey] === internalValue;
      });
      if (index > -1) {
        labelValue = data[index][labelKey];
      }
      if (text !== 'text') {
        if (inputValue != labelValue && inputValue && inputChanged) {
          setSearchWord(String(inputValue));
        } else if (inputValue != labelValue && inputValue && !inputChanged) {
          setSearchWord('');
        } else {
          setSearchWord('');
        }
      }
    }
    if (multiple && newVisible) {
      if (!inputValue) {
        setSearchWord(String(inputValue));
      }
    }
    setVisible(newVisible);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(newVisible);
  }, [disabled, visible, internalValue, searchWord, multiple, onVisibleChange, onSearch, inputValue, inputChanged]);
  var clickoutsideReset = function clickoutsideReset() {
    if (!multiple && !valueTemplate) {
      if (internalValue) {
        var index = flattenItems.findIndex(function (d) {
          return d[valueKey] === internalValue;
        });
        if (index > -1) {
          var labelValue = flattenItems[index][labelKey];
          setInputValue(labelValue);
        } else {
          setInputValue(internalValue);
        }
      } else {
        setInputValue('');
      }
    }
    if (multiple || valueTemplate) {
      setInputValue('');
    }
    if (inputChanged) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    }
    setInputChanged(false);
  };
  var handleClickOutsidePopup = useCallback(function (event) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(getEventSource(event))) {
      return;
    }
    clickoutsideReset();
    if (visible) {
      toggleOpen();
    }
  }, [toggleOpen, visible, containerRef]);
  var hideOnClickOutside = function hideOnClickOutside() {
    clickoutsideReset();
    if (visible) {
      toggleOpen();
    }
  };
  var handleKeydownOutsidePopup = function handleKeydownOutsidePopup(event) {
    var key = event.key;
    var shiftKey = event.shiftKey;
    if (shiftKey && key === KEY_VALUES.TAB) {
      var element = getActiveElement();
      var preEle = getNextFocusableElement(popupRef.current, element, true);
      if (!preEle) {
        var _targetRef$current2;
        (_targetRef$current2 = targetRef.current) === null || _targetRef$current2 === void 0 ? void 0 : _targetRef$current2.focus();
      }
      event.preventDefault();
    }
  };
  useKeydownOutside({
    enabled: dropdownRenderMode === 'portal' ? true : false,
    isOutside: function isOutside(event) {
      var _popupRef$current;
      return (_popupRef$current = popupRef.current) === null || _popupRef$current === void 0 ? void 0 : _popupRef$current.contains(event.target);
    },
    handle: handleKeydownOutsidePopup
  });
  useClickOutside({
    enabled: dropdownRenderMode === 'default' ? true : false,
    isOutside: function isOutside(event) {
      var _containerRef$current2, _popupRef$current2;
      var eventSource = getEventSource(event);
      return !((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(eventSource)) && !((_popupRef$current2 = popupRef.current) !== null && _popupRef$current2 !== void 0 && _popupRef$current2.contains(eventSource));
    },
    handle: hideOnClickOutside
  });
  useClickOutside({
    enabled: dropdownRenderMode === 'portal' ? true : false,
    isOutside: function isOutside(event) {
      var _popupRef$current3;
      return !((_popupRef$current3 = popupRef.current) !== null && _popupRef$current3 !== void 0 && _popupRef$current3.contains(getEventSource(event)));
    },
    handle: handleClickOutsidePopup
  });
  var _useOptions = useOptions(data, children, childrenKey, valueKey, labelKey, disabledItemValues),
    itemValues = _useOptions.itemValues,
    parsedItems = _useOptions.mergedItems,
    flattenItems = _useOptions.flattenItems;
  var allStatus = useMemo(function () {
    var disabledLen = 0;
    var availCheckedLen = 0;
    flattenItems.forEach(function (flattenItem) {
      if (flattenItem.disabled) {
        disabledLen++;
      }
      if (!flattenItem.disabled && !toArray(internalValue).includes(flattenItem[valueKey])) {
        availCheckedLen++;
      }
    });
    var total = itemValues.length;
    var allChecked = flattenItems.length > 0 && (availCheckedLen === 0 && toArray(internalValue).length > 0 || total === toArray(internalValue).length);
    var allDisabled = disabledLen === total;
    return {
      _allChecked: allChecked,
      _allDisabled: allDisabled
    };
  }, [children, internalValue, flattenItems]);
  var allChecked = allStatus._allChecked,
    allDisabled = allStatus._allDisabled;
  var text = useMemo(function () {
    var selectedString = '';
    var len = toArray(internalValue).length;
    if (multiple && len === flattenItems.length && flattenItems.length > 0) {
      selectedString = typeof selectAllText === 'undefined' ? t('allSelectedMessage') : selectAllText;
    } else if (multiple) {
      var _values = toArray(internalValue);
      var _result = _values.filter(function (value) {
        return flattenItems.findIndex(function (flattenItem) {
          return flattenItem[valueKey] === value;
        }) > -1;
      });
      if (_result.length > 0) {
        selectedString = t('selectionMessage').replace("{0}", String(_result.length));
      }
    } else {
      var index = flattenItems.findIndex(function (item) {
        return item[valueKey] === internalValue;
      });
      if (index > -1) {
        selectedString = flattenItems[index][labelKey];
      }
    }
    return selectedString;
  }, [placeholder, internalValue, allChecked, multiple, flattenItems]);
  var filteredItems = useFilterOptions(parsedItems, childrenKey, labelKey, valueKey, searchWord, filterOption);
  var displayItems = React.useMemo(function () {
    return flattenItemsFun(filteredItems, {
      childrenAsData: childrenAsData,
      childrenKey: childrenKey,
      valueKey: valueKey,
      labelKey: labelKey
    });
  }, [filteredItems, childrenAsData, childrenKey, valueKey, labelKey]);
  var handleValueChange = function handleValueChange(v, keyboard) {
    var _inputRef$current2;
    keyboard && ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus());
    if (!multiple) {
      setInternalValue(v);
      var index = flattenItems.findIndex(function (d) {
        return d[valueKey] === v;
      });
      if (index > -1 && !valueTemplate) {
        var labelValue = flattenItems[index][labelKey];
        setInputValue(labelValue);
      }
      toggleOpen();
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(v);
      return;
    }
    var newValues = toArray(internalValue);
    if (newValues.includes(v)) {
      newValues = newValues.filter(function (i) {
        return i !== v;
      });
    } else {
      newValues.push(v);
    }
    setInternalValue(newValues);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(newValues);
  };
  var onInternalSelect = useCallback(function (v, item, e, k) {
    var _inputRef$current3;
    e.stopPropagation();
    setInputChanged(false);
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    if (k && !focusItemValue.keyboard) return;
    if (v === SELECT_ALL_KEY) {
      var _inputRef$current4;
      var newValues = [];
      if (allChecked) {
        flattenItems.forEach(function (flattenItem) {
          var value = flattenItem[valueKey];
          if (flattenItem.disabled && internalValue.includes(value)) {
            newValues.push(value);
          }
        });
        if (!isControlled) {
          setInternalValue(newValues);
        }
      } else {
        flattenItems.forEach(function (flattenItem) {
          var value = flattenItem[valueKey];
          if (!flattenItem.disabled || flattenItem.disabled && toArray(internalValue).includes(value)) {
            newValues.push(flattenItem[valueKey]);
          }
        });
        if (!isControlled) {
          setInternalValue(newValues);
        }
      }
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(newValues);
      k && ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.focus());
      return;
    }
    var value = internalValue;
    var vals = [];
    if (isControlled) {
      if (multiple || valueTemplate) {
        value = toArray(value);
        if (value.includes && value.includes(v)) {
          vals = value.filter(function (ele) {
            return ele !== v;
          });
        } else {
          vals = value.concat(v);
        }
      } else {
        vals = v;
        var index = data.findIndex(function (d) {
          return d[valueKey] === v;
        });
        if (index > -1) {
          var _label2 = data[index][labelKey];
          setInputValue(_label2);
        }
      }
      k && inputRef.current.focus();
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(vals);
      if (!multiple) {
        toggleOpen();
      }
    } else {
      handleValueChange(v, k);
    }
    if (!k) {
      var newFocusValue = {
        keyboard: false,
        value: v
      };
      setFocusItemValue(newFocusValue);
    }
  }, [toggleOpen, handleValueChange, onSelect, internalValue]);
  var getFocusableItems = function getFocusableItems() {
    return displayItems.filter(function (item) {
      return !item.isGroup && !item.data.disabled && !(disabledItemValues !== null && disabledItemValues !== void 0 && disabledItemValues.includes(item[valueKey]));
    });
  };
  var findFocusItemValue = function findFocusItemValue(offset, isUp) {
    var focusableItems = getFocusableItems();
    if (isUp) {
      focusableItems = focusableItems.reverse();
    }
    var value = focusItemValue.value;
    if (focusableItems.length > 0) {
      var focusValue = focusableItems[0][valueKey];
      var index = -1;
      if (!value && value !== 0) {
        for (var i = 0; i < focusableItems.length; ++i) {
          var _value = focusableItems[i][valueKey];
          if (!multiple && internalValue === _value || multiple && toArray(internalValue).includes(_value)) {
            index = i;
          }
        }
        if (index > -1) {
          focusValue = focusableItems[index][valueKey];
        } else {
          focusValue = focusableItems[0][valueKey];
        }
        setFocusItemValue({
          keyboard: true,
          value: focusValue
        });
        return;
      }
      var len = focusableItems.length;
      var focusItemIndex = focusableItems.findIndex(function (item) {
        return item[valueKey] === value;
      });
      if (offset === 0 && value !== undefined) {
        focusValue = focusableItems[focusItemIndex][valueKey];
        setFocusItemValue({
          keyboard: true,
          value: focusValue
        });
      }
      var newIndex = focusItemIndex;
      if (offset > 0) {
        newIndex = focusItemIndex + 1 >= len ? 0 : focusItemIndex + 1;
      } else if (offset < 0) {
        newIndex = focusItemIndex - 1 < 0 ? len - 1 : focusItemIndex - 1;
      }
      focusValue = focusableItems[newIndex][valueKey];
      setFocusItemValue({
        keyboard: true,
        value: focusValue
      });
    }
  };
  var getNextFocusableElement = function getNextFocusableElement(findElement, element, isPre) {
    if (isPre === void 0) {
      isPre = false;
    }
    var controls = "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n        [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])";
    var focusable = findElement === null || findElement === void 0 ? void 0 : findElement.querySelectorAll(controls); //(containerRef.current! as HTMLElement)?
    var index = Array.prototype.indexOf.call(Array.from(focusable), element);
    return Array.from(focusable)[isPre ? index - 1 : index + 1];
  };
  var onKeyDown = function onKeyDown(event) {
    // event.stopPropagation();
    var key = event.key;
    var isDown = key === KEY_VALUES.DOWN;
    var isUp = key === KEY_VALUES.UP;
    var isEnter = key === KEY_VALUES.ENTER;
    var isSpace = key === KEY_VALUES.SPACE;
    if (!visible) {
      if (isEnter || isDown || isSpace || isUp) {
        event.preventDefault();
        event.stopPropagation();
        toggleOpen();
        dropdownRenderMode === 'portal' && window['trap'] && window['trap'].pause();
        findFocusItemValue(0, isUp);
      }
    } else {
      if (dropdownRenderMode === 'portal' && KEY_VALUES.TAB === key) {
        var _containerRef$current3, _targetRef$current3;
        var element = getActiveElement();
        var nextEle = getNextFocusableElement(targetRef.current, element) || getNextFocusableElement(popupRef.current, element);
        if (!((_containerRef$current3 = containerRef.current) !== null && _containerRef$current3 !== void 0 && _containerRef$current3.contains(nextEle)) && !((_targetRef$current3 = targetRef.current) !== null && _targetRef$current3 !== void 0 && _targetRef$current3.contains(nextEle))) {
          clickoutsideReset();
          toggleOpen();
        } else if (visible) {
          var _selected = toArray(internalValue).filter(function (v) {
            return (flattenItems === null || flattenItems === void 0 ? void 0 : flattenItems.findIndex(function (d) {
              return d[valueKey] === v;
            })) > -1;
          }).length > 0;
          if (!_selected && !inputValue) {
            clickoutsideReset();
            toggleOpen();
          }
        }
        return;
      }
      switch (key) {
        case KEY_VALUES.UP:
        case KEY_VALUES.DOWN:
          {
            inputRef.current.focus();
            var offset = 0;
            if (key === KEY_VALUES.UP) {
              offset = -1;
            } else if (key === KEY_VALUES.DOWN) {
              offset = 1;
            }
            if (offset !== 0) {
              findFocusItemValue(offset);
            }
            event.preventDefault();
            event.stopPropagation();
            break;
          }
        // >>> Select
        case KEY_VALUES.ENTER:
        case KEY_VALUES.SPACE:
          {
            if (KEY_VALUES.SPACE === key) {
              return;
            }
            if (displayItems.length === 0) {
              return;
            }
            var index = flattenItems.findIndex(function (item) {
              return item[valueKey] === focusItemValue.value;
            });
            onInternalSelect(focusItemValue.value, flattenItems[index], event, true);
            if (visible) {
              event.preventDefault();
            }
            break;
          }
        // >>> Close
        case KEY_VALUES.ESC:
          {
            var _targetRef$current4;
            toggleOpen();
            (_targetRef$current4 = targetRef.current) === null || _targetRef$current4 === void 0 ? void 0 : _targetRef$current4.focus();
            if (visible) {
              window['trap'] && window['trap'].unpause();
              event.stopPropagation();
            }
            break;
          }
      }
    }
  };
  var onInternalSearch = function onInternalSearch(v) {
    setSearchWord(v);
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(v);
  };
  var selectWrapper = ClassNames(prefixCls, className, (_ClassNames = {}, _ClassNames[prefixCls + "-multiple"] = multiple, _ClassNames[prefixCls + "-single"] = !multiple, _ClassNames[prefixCls + "-multiple-tags"] = multiple && showMultipleTags, _ClassNames.disabled = disabled, _ClassNames.error = error, _ClassNames.visible = visible, _ClassNames));
  if (multiple && showSelectAll) {
    if (displayItems && displayItems.length > 0) {
      var firstItem = displayItems[0];
      if (firstItem[valueKey] !== SELECT_ALL_KEY) {
        var _data, _displayItems$unshift;
        displayItems.unshift((_displayItems$unshift = {}, _displayItems$unshift[labelKey] = selectAllText || t('selectAll'), _displayItems$unshift[valueKey] = SELECT_ALL_KEY, _displayItems$unshift.disabled = allDisabled, _displayItems$unshift.data = (_data = {}, _data[labelKey] = selectAllText || t('selectAll'), _data[valueKey] = SELECT_ALL_KEY, _data.disabled = allDisabled, _data), _displayItems$unshift));
      }
    }
  }
  var context = React.useMemo(function () {
    return {
      disabledItemValues: disabledItemValues,
      parsedItems: flattenItems,
      flattenItems: displayItems,
      onSelect: onInternalSelect,
      selectedValues: internalValue,
      childrenAsData: childrenAsData,
      focusItemValue: focusItemValue,
      searchWord: searchWord
    };
  }, [disabledItemValues, flattenItems, displayItems, onInternalSelect, internalValue, childrenAsData, focusItemValue, searchWord]);
  var dropdownMenu = function dropdownMenu(portal) {
    return /*#__PURE__*/React.createElement(DropdownMenu, {
      id: controlsId,
      role: 'listbox',
      style: dropdownStyle,
      className: ClassNames('ap-combobox-dropdown-list', dropdownClassName, {
        'ap-combobox-dropdown-list-default': dropdownRenderMode === 'default',
        'ap-combobox-dropdown-list-portal': dropdownRenderMode === 'portal'
      }),
      ref: popupRef,
      visible: !disabled && visible,
      showSelectAll: showSelectAll,
      selectedAllChecked: allChecked,
      selectedAllDisabled: allDisabled,
      multiple: multiple,
      searchWord: searchWord,
      onSearch: onInternalSearch,
      labelKey: labelKey,
      valueKey: valueKey,
      childrenKey: childrenKey,
      itemTemplate: itemTemplate,
      badgeTemplate: badgeTemplate,
      prefixTemplate: prefixTemplate,
      suffixTemplate: suffixTemplate,
      groupTemplate: groupTemplate,
      dropdownRender: dropdownRender,
      noResultFound: noResultFound || t('noResultMessage')
    });
  };
  var ele = null;
  if (getPopupContainer || dropdownRenderMode === 'portal') {
    ele = /*#__PURE__*/React.createElement(Portal, {
      element: /*#__PURE__*/React.createElement(CSSTransition, {
        nodeRef: overlayRef,
        classNames: "ap-combobox-dropdown-overlay",
        "in": visible,
        timeout: {
          enter: 300,
          exit: 100
        },
        unmountOnExit: true
      }, /*#__PURE__*/React.createElement("div", {
        ref: overlayRef,
        className: "ap-combobox-dropdown-overlay"
      }, dropdownMenu(true))),
      container: getPopupContainer
    });
  } else {
    ele = /*#__PURE__*/React.createElement(CSSTransition, {
      nodeRef: overlayRef,
      classNames: "ap-combobox-dropdown-overlay",
      "in": visible,
      timeout: {
        enter: 300,
        exit: 300
      },
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement("div", {
      ref: overlayRef,
      className: "ap-combobox-dropdown-overlay"
    }, dropdownMenu()));
  }
  var renderTags = function renderTags() {
    var onDeselect = function onDeselect(value) {
      var newValues = toArray(internalValue).filter(function (v) {
        return v !== value;
      });
      setInternalValue(newValues);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(newValues);
    };
    var values = toArray(internalValue);
    return /*#__PURE__*/React.createElement(React.Fragment, null, allChecked && showAllSelectedTag ? /*#__PURE__*/React.createElement("div", {
      className: "ap-combobox-selection-overflow-item"
    }, /*#__PURE__*/React.createElement(Tag, {
      size: "sm",
      disabled: disabled,
      closable: false,
      className: "combobox-tag select-all-tag"
    }, text)) : /*#__PURE__*/React.createElement(React.Fragment, null, values.length > 0 && values.map(function (value, index) {
      var labelIndex = flattenItems.findIndex(function (flattenItem) {
        return flattenItem[valueKey] === value;
      });
      var tagValue = '';
      if (labelIndex > -1) {
        tagValue = flattenItems[labelIndex][labelKey];
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "ap-combobox-selection-overflow-item"
      }, /*#__PURE__*/React.createElement(Tag, {
        size: "sm",
        disabled: disabled,
        onClose: function onClose() {
          return onDeselect(value);
        }
      }, tagValue));
    })), /*#__PURE__*/React.createElement("div", {
      className: "ap-combobox-selection-overflow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ap-combobox-selection-overflow-item ap-combobox-selection-overflow-item-suffix"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ap-combobox-selection-search",
      style: {
        width: inputWidth,
        maxWidth: maxWidth
      }
    }, /*#__PURE__*/React.createElement("input", _extends({
      ref: inputRef,
      role: "combobox",
      className: "ap-combobox-selection-search-input",
      type: "text",
      required: required,
      readOnly: readonly,
      disabled: disabled,
      "aria-disabled": disabled,
      "aria-readonly": readonly,
      value: inputValue,
      onChange: handleChange,
      onKeyDown: handleInputKeyDown
    }, inputProps)), /*#__PURE__*/React.createElement("div", {
      ref: measureRef,
      className: "ap-combobox-selection-search-mirror",
      "aria-hidden": true
    }, inputValue, "\xA0")))), inputValue.length === 0 && values.length === 0 && /*#__PURE__*/React.createElement("span", {
      className: "ap-combobox-selection-placeholder",
      "aria-hidden": true
    }, placeholder || t('comboboxPlaceholder'), required && /*#__PURE__*/React.createElement("span", {
      className: "ap-combobox-required-indicator"
    })));
  };
  var triggerClasses = ClassNames('ap-combobox-input-box', {
    disable: disabled,
    error: error,
    visible: visible,
    'keyboard-focus': keyboardFocus
  });
  var triggerIconClasses = ClassNames('Appkit4-icon icon-down-chevron-outline', {
    up: visible,
    disabled: disabled
  });
  var handleChange = useCallback(function (event) {
    var value = event.target.value;
    setInputValue(value);
    setSearchWord(value);
    if (value && !visible) {
      toggleOpen('text');
    }
    setInputChanged(true);
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
  }, [setInputValue, setSearchWord, visible, toggleOpen]);
  var handleClick = function handleClick(event) {
    var target = event.target;
    if (target !== inputRef.current) {
      // Should focus input if click the selector
      var isIE = document.body.style.msTouchAction !== undefined;
      if (isIE) {
        setTimeout(function () {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
    if (visible) {
      return;
    }
    var newFocusValue = _extends({}, focusItemValue, {
      keyboard: false
    });
    setFocusItemValue(newFocusValue);
    handleToggle();
  };
  var handleInputKeyDown = function handleInputKeyDown(event) {};
  var handleClear = function handleClear(event, isKeyboard) {
    var _inputRef$current5;
    if (isKeyboard === void 0) {
      isKeyboard = false;
    }
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    setInputValue('');
    setSearchWord('');
    if (multiple) {
      setInternalValue([]);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect([]);
    } else {
      setInternalValue('');
      onSelect === null || onSelect === void 0 ? void 0 : onSelect('');
    }
    !isKeyboard && setKeyboardFocus(false);
    (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.focus();
    onClear === null || onClear === void 0 ? void 0 : onClear();
    if (inputChanged) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
      setInputChanged(false);
    }
  };
  var handleClearKeyDown = function handleClearKeyDown(event) {
    if (event.key === KEY_VALUES.ENTER) {
      event.preventDefault();
      event.stopPropagation();
      handleClear === null || handleClear === void 0 ? void 0 : handleClear(event, true);
    }
  };
  var values = toArray(internalValue);
  var result = flattenItems.filter(function (flattenItem) {
    return values.findIndex(function (value) {
      return flattenItem[valueKey] === value;
    }) > -1;
  });
  var selected = result.length > 0;
  var ourProps = {
    ref: targetRef,
    'aria-expanded': visible,
    'aria-haspopup': true,
    'aria-labelledby': 'combobox-label',
    'aria-live': 'polite',
    onClick: handleClick,
    className: triggerClasses
  };
  if (showMultipleTags) {}
  var valueTemplateNode = null;
  if (valueTemplate && typeof valueTemplate === 'function' && selected) {
    valueTemplateNode = valueTemplate(internalValue, multiple ? result : result[0]);
  }
  var triggerNode = /*#__PURE__*/React.createElement("div", ourProps, valueTemplateNode ? /*#__PURE__*/React.createElement("div", {
    className: "ap-combox-custom-wrapper " + (selected && 'show-text')
  }, valueTemplateNode) : multiple && showMultipleTags ? /*#__PURE__*/React.createElement("div", {
    className: "ap-combox-tags-wrapper"
  }, renderTags()) : multiple && selected && /*#__PURE__*/React.createElement(Tag, {
    size: "sm",
    className: ClassNames('combobox-tag', {
      'select-all-tag': allChecked
    }),
    disabled: disabled,
    closable: false
  }, text), !showMultipleTags && /*#__PURE__*/React.createElement("div", {
    className: "ap-combobox-input-wrapper"
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef,
    role: "combobox",
    className: ClassNames('ap-combobox-selection-search-input', {
      'has-text': inputValue.length > 0
    })
    // className={`ap-combobox-input ${
    //   multiple && selected ? 'ap-combobox-input-short' : ''
    // }`}
    // placeholder={
    //   (multiple || valueTemplate) && selected
    //     ? ''
    //     : placeholder || t('comboboxPlaceholder')
    // }
    ,
    type: "text",
    required: required,
    readOnly: readonly,
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-readonly": readonly,
    value: inputValue,
    onChange: handleChange,
    onKeyDown: handleInputKeyDown
  }, inputProps)), inputValue.length === 0 && values.length === 0 && /*#__PURE__*/React.createElement("span", {
    className: "ap-combobox-selection-placeholder",
    "aria-hidden": true
  }, placeholder || t('comboboxPlaceholder'), required && /*#__PURE__*/React.createElement("span", {
    className: "ap-combobox-required-indicator"
  }))), showClear ? /*#__PURE__*/React.createElement("span", {
    className: ClassNames('ap-combobox-clear-icon', {
      showDeleteIcon: selected && !inputChanged || multiple && selected,
      disabled: disabled
    }),
    role: "button",
    tabIndex: disabled ? -1 : 0,
    "aria-label": t("clear"),
    onClick: handleClear,
    onKeyDown: handleClearKeyDown
  }, /*#__PURE__*/React.createElement("i", {
    className: "Appkit4-icon icon-circle-delete-outline"
  })) : null, showDividerProp && (inputValue || multiple && selected) ? /*#__PURE__*/React.createElement("span", {
    className: "separte-line"
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "ap-combobox-toggle-box",
    onClick: function onClick(e) {
      e.stopPropagation();
      var newFocusValue = _extends({}, focusItemValue, {
        keyboard: false
      });
      setFocusItemValue(newFocusValue);
      handleToggle === null || handleToggle === void 0 ? void 0 : handleToggle();
    },
    role: "button",
    tabIndex: -1,
    "aria-label": t("aria").toggleButtonLabel,
    "aria-expanded": visible
  }, /*#__PURE__*/React.createElement("i", {
    className: ClassNames('Appkit4-icon icon-down-chevron-outline', {
      readonly: readonly,
      disabled: disabled,
      up: visible,
      down: !visible
    }),
    alt: "toggle icon",
    "aria-hidden": true,
    "aria-expanded": visible
  })));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: mergeRefs(ref, containerRef),
    id: id,
    className: selectWrapper,
    style: style,
    onKeyDown: onKeyDown
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: "search-result",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, (displayItems === null || displayItems === void 0 ? void 0 : displayItems.length) > 0 ? (_resultMessage = t("aria").resultMessage) === null || _resultMessage === void 0 ? void 0 : _resultMessage.replace("{0}", String(displayItems === null || displayItems === void 0 ? void 0 : displayItems.length)) : noResultFound || t("noResultMessage")), /*#__PURE__*/React.createElement(OptionListContext.Provider, {
    value: context
  }, triggerNode, ele), error && /*#__PURE__*/React.createElement("div", {
    className: "ap-combobox-error"
  }, errorNode));
});
Combobox.displayName = 'Combobox';
export default Combobox;